import dayjs from 'dayjs';
import { DateRangePickerValue } from '../components/date-range-picker';

export const isValidDate = (date: DateRangePickerValue): boolean =>
  date ? dayjs(date).isValid() : false;
